import React, { Fragment } from "react";
import { Image } from "react-bootstrap";
import Button from "../Button/Button";

import classes from "./MessageAlert.module.css";
import sessionImage from "../../../assets/images/session.png";
import { withTranslation } from "react-i18next";

interface Props {
  modalClosed: () => void;
  error: string;
  t: any;
}


  const btnStyle = {
    marginTop:"10px",
  };

  const LogoutAlert: React.FunctionComponent<Props> = (props) => {
    const { modalClosed, error } = { ...props };
    return (
      <Fragment>
        <div className="popupHeader popupHeaderBdr">
          <div className="closeBtn closeBtnBlue" onClick={modalClosed}>
            X
          </div>
        </div>

        <div className={classes.popupBody}>
          <Image
            src={sessionImage}
            alt={sessionImage}
            className={classes.errorImage}
          />
          <div className={classes.networkAlert}>
            <h4>{props.t('error.logoutSession')}</h4>
            <strong>
              {props.t('error.logoutErrorText')}
            </strong>
          </div>
          <Button
            label={props.t('error.logooutBtn')}
            clicked={modalClosed}
            style={btnStyle}
            displayImg={false}
            image=""
            disabled={false}
          />
        </div>
      </Fragment>
    );
  };
  export default withTranslation()(LogoutAlert);
